// import $ from 'jquery';
import Lenis from '@studio-freight/lenis'
import Swiper from 'swiper/bundle';
// import 'swiper/css';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { bgRandomAnimation } from './bganimation'

// gsap scrollTrigerr
gsap.registerPlugin(ScrollTrigger);
// bgRandomAnimation(gsap)
const isSmartPhone = () => {
  if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
    return true;
  } else {
    return false;
  }
};

const spanWrapText = (target) => {
  const nodes = [...target.childNodes];
  let returnText = '';

  for (const node of nodes) {
    if (node.nodeType == 3) {
      const text = node.textContent.replace(/\r?\n/g, '');
      const splitText = text.split('');
      for (const char of splitText) {
        returnText += `<span>${char}</span>`;
      }
    } else {
      returnText += node.outerHTML;
    }
  }
  return returnText;
};


document.querySelectorAll('.js-header-menu').forEach((menuitem)=>{
  menuitem.addEventListener("click", (e)=>{
    document.querySelector('.js-header-menu-button').classList.remove('is-active')
  })
})
gsap.to(".js-main-logo", { 'clip-path': 'polygon(0 0%, 100% 0%, 100% 100%, 0% 100%)', delay:.5, duration: 1.7});

const members = gsap.utils.toArray('.js-member-item');
gsap.fromTo(members, 
  {
    y:30,
    opacity:0,
  },
  {
    y:0,
    opacity:1,
    duration: .5,
    delay: .25,
    stagger: .15,
    scrollTrigger: {
      trigger: members,
      start: "top top",
    }
  })

const sectionTitleElement = gsap.utils.toArray('.js-enter-active');
if (sectionTitleElement) {
    sectionTitleElement.forEach((element, index) => {
        gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top center',
                onEnter: () => element.classList.add('is-active'),
            }
        });
    });
}

const parallaxSections = gsap.utils.toArray('.js-parallax-section:not(:first-child)');
console.log(parallaxSections)
if (parallaxSections.length!=0) {

  const wrapper = document.querySelector('.js-parallax-sections');
  gsap.set(parallaxSections, { 'clip-path': 'inset(100% 0 0% 0%)' });
  gsap.to(parallaxSections, { 'clip-path': 'inset(0% 0 0% 0%)', duration: 1, stagger: 1
    ,scrollTrigger: {
      trigger: wrapper,
      start: "top top",
      end: "bottom+=200 top",
      pin: true,
      scrub: 3,
      duration: 3,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: {
        snapTo: 1 / (parallaxSections.length),
        directional: false,
        duration: {min: 0.25, max: 0.75}, // the snap animation should be at least 0.25 seconds, but no more than 0.75 seconds (determined by velocity)
        delay: 0.125, // wait 0.125 seconds from the last scroll event before doing the snapping
        ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
      }
    },
  })
}

const lenis = new Lenis({
  duration: 0,
})
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})
gsap.ticker.lagSmoothing(0)
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)
const anchors = document.querySelectorAll(".js-anchor");
anchors.forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    e.preventDefault();
    let to = e.currentTarget.getAttribute('href')
    if (to==="#about") {
      to = window.innerHeight;
    }
    lenis.scrollTo(to);
  });
})

